import { DetailedHTMLProps, FC, ImgHTMLAttributes, useLayoutEffect, useState } from 'react';
import QRCode from 'qrcode';

interface QrImageProps extends Omit<
  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
  'src'
> {
  dataForQRCode: string;
}

export const QrImage: FC<QrImageProps> = ({ dataForQRCode, ...props }) => {
  const [imageSrc, setImageSrc] = useState<string>('');
  useLayoutEffect(() => {
    QRCode.toDataURL(dataForQRCode, { type: 'image/webp' }).then((data) => setImageSrc(data));
  }, [dataForQRCode]);

  if (!imageSrc) {
    return null;
  }

  return <img width="120" height="120" src={imageSrc} alt="QR-code" {...props} />;
};
